module.exports = __webpack_public_path__ + "img/1F614.05ec6164.svg";